export default "__VITE_ASSET__04e37796__"